/**
 * Smoothly scrolls the window to the top using a cubic easing function.
 * @param {number} duration - The duration of the scroll animation in milliseconds.
 */
export const smoothScrollToTop = (duration = 800) => {
  const start = window.scrollY;
  const startTime = performance.now();

  const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);

  const scroll = (currentTime) => {
    const time = Math.min(1, (currentTime - startTime) / duration);
    const eased = easeOutCubic(time);

    window.scrollTo(0, start * (1 - eased));

    if (time < 1) {
      requestAnimationFrame(scroll);
    }
  };

  requestAnimationFrame(scroll);
};
